import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";

import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {/* <body
      className='body'
      style={{
        background: `linear-gradient( rgba(255, 255, 255, 0.61), rgba(255, 255, 255, 0.61)), url(${background})`,
        backgroundSize: 'cover'
      }}
      

    > */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* </body> */}
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
